
import { enterpriseSearch, enterpriseInfo } from "@/api/enterprise";
// import jsMide from './components/jsMide.vue'
import hangyeJson from "@/data/hangye.json";
import qiyexingzhiJson from "@/data/qiyexingzhi.json";
import qixinbaoJson from "@/data/qixinbao.json";
import changyeJson from "@/data/changye1.json";
export default {
  layout: "base",
  data() {
    return {
      searchData: "",
      light: "purple",
      doShow: true,
      showMsg: true,
      isSearchLoading: false,
      activeName: "1",
      news: [],
      visiblePop: false,
      hanYe: hangyeJson.data,
      qiyezizhi: qiyexingzhiJson.data,
      changyeArr: changyeJson.data,
      qixinbao: [],
      page: 1,
      total: 0,
      searchList: [],
      provinces: [
        // 请选择
        { label: "请选择", value: "" },
        { label: "北京", value: "110000" },
        { label: "天津", value: "120000" },
        { label: "广东", value: "440000" },
        { label: "广西", value: "450000" },
        { label: "湖南", value: "430000" },
        { label: "湖北", value: "420000" },
        { label: "河南", value: "410000" },
        { label: "河北", value: "130000" },
        { label: "山西", value: "140000" },
        { label: "内蒙古", value: "150000" },
        { label: "辽宁", value: "210000" },
        { label: "吉林", value: "220000" },
        { label: "黑龙江", value: "230000" },
        { label: "江苏", value: "320000" },
        { label: "浙江", value: "330000" },
        { label: "安徽", value: "340000" },
        { label: "福建", value: "350000" },
        { label: "江西", value: "360000" },
        { label: "山东", value: "370000" },
        { label: "台湾", value: "710000" },
        { label: "海南", value: "460000" },
        { label: "四川", value: "510000" },
        { label: "贵州", value: "520000" },
        { label: "云南", value: "530000" },
        { label: "西藏", value: "540000" },
        { label: "陕西", value: "610000" },
        { label: "甘肃", value: "620000" },
        { label: "青海", value: "630000" },
        { label: "宁夏", value: "640000" },
        { label: "新疆", value: "650000" },
        { label: "香港", value: "810000" },
        { label: "澳门", value: "820000" },
        { label: "上海", value: "310000" },
      ],
      industry_codes: [
        // 请选择
        { label: "请选择", value: "" },
        { label: "农、林、牧、渔业", value: "A0000" },
        { label: "采矿业", value: "B0000" },
        { label: "制造业", value: "C0000" },
        { label: "电力、热力、燃气及水生产和供应业", value: "D0000" },
        { label: "建筑业", value: "E0000" },
        { label: "批发和零售业", value: "F0000" },
        { label: "住宿和餐饮业", value: "H0000" },
        { label: "金融业", value: "J0000" },
        { label: "房地产业", value: "K0000" },
        { label: "租赁和商务服务业", value: "L0000" },
        { label: "科学研究和技术服务业", value: "M0000" },
        { label: "水利、环境和公共设施管理业", value: "N0000" },
        { label: "居民服务、修理和其他服务业", value: "S0000" },
        { label: "文化、体育和娱乐业", value: "R0000" },
        { label: "公共管理、社会保障和社会组织", value: "O0000" },
        { label: "教育", value: "P0000" },
        { label: "信息传输、软件和信息技术服务业", value: "I0000" },
        { label: "交通运输、仓储和邮政业", value: "G0000" },
        { label: "卫生和社会工作", value: "Q0000" },
      ],
      enterprisetypes: [
        { label: "国有企业", value: "国有企业" },
        { label: "集体企业", value: "集体企业" },
        { label: "股份合作企业", value: "股份合作企业" },
        { label: "联营企业", value: "联营企业" },
        { label: "有限责任公司", value: "有限责任公司" },
        { label: "股份有限公司", value: "股份有限公司" },
        { label: "私营企业", value: "私营企业" },
        { label: "港、澳、台商投资企业", value: "港、澳、台商投资企业" },
        { label: "外商投资企业", value: "外商投资企业" },
        { label: "个体工商户", value: "个体工商户" },
        { label: "内资企业分支机构", value: "内资企业分支机构" },
        {
          label: "港、澳、台商投资企业分支机构",
          value: "港、澳、台商投资企业分支机构",
        },
        { label: "外商投资企业分支机构", value: "外商投资企业分支机构" },
        { label: "其他企业", value: "其他企业" },
      ],
      // 注册资本
      capi_from: "",
      capi_to: "",
      // 注册资本是否自定义
      isCustom: false,
      econ_type: [],
      industry_code: "",
      province: "",
      searchType: [],
    };
  },
  components: {
    // jsMide
  },
  watch: {},
  created() {
    this.fileterData();
  },
  methods: {
    // capiCahnge
    capiCahnge() {
      this.isCustom = false;
      this.getEnterpriseList();
    },

    tabChange() {
      // if (this.activeName == 2) {
      //     setTimeout(() => {
      //       this.$refs.jsMideRef.handleMind()
      //     }, 600)
      // }
    },
    // 搜索
    toSearch(id) {
      const routeUrl = this.$router.resolve({
        path: `/enterpriseDetail/${id}`,
      });
      window.open(routeUrl.href, "_blank");
    },

    // 跳转地图查询产业链
    toResolveEnterChain({ topic, level }) {
      this.$router.push({
        path: `/map`,
        query: {
          chainName: topic,
          level: level.length == 2 ? 1 : 2,
        },
      });
    },

    // 跳转地图查询企业资质
    toResolveQiyexingzhi({ topic, level }) {
      this.$router.push({
        path: `/map`,
        query: {
          companyName: topic,
          level: level.length == 2 ? 1 : 2,
        },
      });
    },

    // 获取该行业下面的企业
    async toResolveEnterPrise(code) {
      this.code = code;
      this.isSearchLoading = true;
      const res = await enterpriseSearch({
        industry_code: code,
        keyword: "深圳",
        is_total: 1,
        skip: this.page - 1,
      });
      this.isSearchLoading = false;
      if (res) {
        this.total = res.data.total;
        this.searchList = res.data.items;
        this.showMsg = false;
      }
    },

    changePage(page) {
      this.page = page;
      if (this.code) {
        this.toResolveEnterPrise(this.code);
      } else {
        this.getEnterpriseList();
      }
    },
    async getEnterpriseList() {
      this.isSearchLoading = true;
      this.showMsg = false;

      if (!this.isCustom) {
        if (this.capi_from === 0) {
          this.capi_to = "100";
        } else if (this.capi_from == 100) {
          this.capi_to = "200";
        } else if (this.capi_from == 200) {
          this.capi_to = "500";
        } else if (this.capi_from == 500) {
          this.capi_to = "1000";
        } else if (this.capi_from == 1000) {
          this.capi_to = "100000000";
        }
      }

      const res = await enterpriseSearch({
        keyword: this.searchData,
        skip: this.page - 1,
        is_total: 1,
        area_code: this.province,
        industry_code: this.industry_code,
        econ_type: this.econ_type.join(","),
        method: this.searchType.join(","),
        capi_from: this.capi_from,
        capi_to: this.capi_to,
      });
      this.isSearchLoading = false;
      if (res) {
        this.total = res.data.total;
        this.searchList = res.data.items;
      }
    },

    goBack() {
      this.showMsg = true;
    },
    async fileterData() {
      let arr = qixinbaoJson.data;
      let hanY1 = arr.filter((item) => item.value.indexOf("0000") > -1);
      const hanY2 = arr.filter((item) => item.value.indexOf("0000") == -1);
      this.qixinbao = hanY1.map((item) => {
        let d1 = 0;
        let kids = hanY2.filter((data) => {
          if (data.value[0] == item.value[0]) {
            if (d1 <= 30) {
              d1++;
              return true;
            }
            return false;
          } else {
            return false;
          }
        });
        return {
          root: item,
          children: kids,
        };
      });
      //  console.log(this.hanYe)
    },
    handleQuery() {
      if (!this.searchData) {
        return (this.visiblePop = true);
        //  this.$toasted.error('请输入完整手机号',{position: "top-center", duration: 2000})
      }
      this.code = "";
      this.getEnterpriseList();
    },
  },
};
